/* eslint-disable react/prop-types */
import React, { useState, useContext } from "react";
import axios from "axios";
import { Col, Row, Button, Form, Container } from "react-bootstrap";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Images and Icons
import { MdOutlineRestartAlt } from "react-icons/md";
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";

const ForgotPasswordTutor = () => {
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const businessID = BusinessContext.businessID;
  // Handle State
  const [email, setEmail] = useState("");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const requestPassword = async (e) => {
    e.preventDefault();
    const data = {
      email,
      businessID,
    };
    // Set the processing State
    setSubmitClicked(true);
    const passwordRequest = await axios.post(`/api/tutor/tutor_users/recover/`, data, {
      withCredentials: true,
    });

    if (passwordRequest.status === 200) {
      setSubmitClicked(false);
      return setSuccessMessage(
        "You will be sent an email with further instructions. Please remember to check spam."
      );
    } else {
      setSubmitClicked(false);
      return setErrorMessage("We could not process that password reset request.");
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='AdminRequestPassword'>
      <FadeIn delay={250} duration={450}>
        <Container>
          <Row>
            <Col sm='12'>
              <Form onSubmit={requestPassword} className='shadow p-4 loginForm mx-auto'>
                <h3>Reset Password: Tutor</h3>
                <Row className='mt-3'>
                  <Col sm='12'>
                    <Form.Group controlId='email'>
                      <Form.Label>Email:</Form.Label>
                      <Form.Control
                        type='email'
                        maxLength='256'
                        placeholder='you@yourdomain.com'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className='border'
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
                {submitClicked && errorMessage.length !== "" ? (
                  <Button
                    variant='secondary'
                    size='lg'
                    type='submit'
                    disabled
                    className='mb-3 mt-3'
                  >
                    Processing
                  </Button>
                ) : (
                  <Button variant='primary' size='lg' type='submit' className='mb-3 mt-3'>
                    Reset <MdOutlineRestartAlt />
                  </Button>
                )}
              </Form>
            </Col>
          </Row>
        </Container>
      </FadeIn>
    </div>
  );
};
//export the component
export default ForgotPasswordTutor;
